import { useEffect, useState } from 'react';

import { Box, ButtonBase } from '@mui/material';

import { AddressNoteApi } from '@/api';
import { IcTriangleWarningGray } from '@/assets/images';
import { useToastStore } from '@/store';
import { colors } from '@/theme/variables';

type AddressNotesButtonProps = {
  addressId: string;
  onExpand: () => void;
};

const AddressNotesButton = ({
  addressId,
  onExpand,
}: AddressNotesButtonProps) => {
  const { updateToast } = useToastStore();
  const [notesCount, setNotesCount] = useState<number | null>(null);

  useEffect(() => {
    if (addressId) {
      fetchNotesCount();
    }
  }, [addressId]);

  const fetchNotesCount = async () => {
    try {
      const params = {
        sort: JSON.stringify({ createdAt: -1 }),
        filter: JSON.stringify({ address: addressId }),
      };
      const res = await AddressNoteApi.getAddressNotes(params);
      setNotesCount(res.data.results.length);
    } catch (err: any) {
      updateToast({ open: err, message: err.message });
    }
  };

  if (!notesCount) return null;

  return (
    <ButtonBase
      onClick={onExpand}
      style={{
        borderRadius: 999,
        backgroundColor: colors.grey[20],
        height: 36,
        padding: '0 12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 4,
      }}
      aria-label="Address notes"
    >
      {notesCount > 1 ? (
        <>
          <IcTriangleWarningGray width={18} height={18} />
          <Box
            component="span"
            sx={{
              fontSize: 12,
              fontWeight: 600,
              color: colors.grey[100],
              lineHeight: 1,
            }}
          >
            {notesCount}
          </Box>
        </>
      ) : (
        <IcTriangleWarningGray width={18} height={18} />
      )}
    </ButtonBase>
  );
};

export default AddressNotesButton;
